import script from "./menu-item.vue?vue&type=script&setup=true&lang=js"
export * from "./menu-item.vue?vue&type=script&setup=true&lang=js"

import "./menu-item.vue?vue&type=style&index=0&id=871ce5fe&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-871ce5fe"]])

export default __exports__